import React, { useEffect, useRef, useState } from 'react'
import { isObject, isSet, getCurrentDate, getCurrentTime } from '../../../utils/commonUtils';
import FormInputs from '../../../components/UI/FormInputs';
import EmrVisitsService from '../../../services/EmrVisitsService';
import LeftRightInput from '../Forms/LeftRight';
import NormalAbnormal from '../Forms/NormalAbnormal';
import PositiveNegative from '../Forms/PositiveNegative';
import RangeOfMotion from '../Forms/RangeOfMotion';
import DropDown from '../Forms/DropDown';
import WithRoutify from '../../../hoc/WithRoutify';
import Exercise from '../Forms/Exercise';
import Buttons from '../../../components/UI/Buttons';
import EmrConfigService from '../../../services/EmrConfigService';
import CustomMatrix from '../Forms/CustomMatrix';
import Alert from '../../../components/UI/ConfirmBox/Alert';

const EmrRenderForm = (props) => {
  const {
     allfields,
    fields,
    visit_id,
    employeeId,
    Toast,
    highlightTerm,
    expandedSection,
    setExpandedSection,
    setProgressApiTrigger,
    selectedSubTab,
    fetchProgressNotesByScreen,
    onFormUpdate,
    completedFormIds,
    setCompetedFormIds,
    fetchTabsList,
    finishedSubTabs,
    finishedTabs,
    SetFinishedSubTabs,
    SetFinishedTabs,
    tabData,
    setNormalCheckedFormIds,
    handleTick,
    isClear,
    setFormState,
    formState,
    EmrRenderForm,
    setIsFormDirty,
    selectedTab,
    registerSaveCurrentCharting,
  } = props;
  const fieldRefs = useRef({});
  const chartingColumnRef = useRef(null); // scrollable right column – scroll this instead of window
  // const [formState, setFormState] = useState({});
  const sectionRefs = useRef({});
  const collapseRefs = useRef({});
  const [validation, setValidation] = useState({});
  const [normalSelectedId, setNormalSelectedId] = useState("");
  const [checked, setChecked] = useState(false);
  const [searchText,setSeachText]=useState("")
  const [inputFields,setInputFields]=useState([])
  const initialFormStateRef = useRef({}); // <
  const latestSaveRef = useRef(null);
  useEffect(() => {
    const newFormState = {};
    let shouldUpdate = false;
    
      fields.forEach((form) => {
        form.fields.forEach((field) => {
          if (!(field.id in formState)) {
            const prefill = field.prefillValue;
            if (prefill !== undefined) {
              if (field.field_type?.input_type === "MULTI_SELECT") {
                newFormState[field.id] = prefill ? prefill.split(",") : [];
              } else if (field.field_type?.input_type === "DROP_DOWN") {
                if (prefill.trim() === "") {
                  newFormState[field.id] = ""
                } else {
                  if (field.ismultiselect === 1) {
                    newFormState[field.id] = Array.isArray(prefill) ? prefill : JSON.parse(prefill);
                  } else {
                      newFormState[field.id] = Array.isArray(prefill) ? prefill : JSON.parse(prefill);
                  }
                }
              } else if (field.field_type?.input_type === "DIGITAL_SIGNATURE") {
                // Handle both old format (base64 string) and new format (JSON with signature, signed_date, signed_time)
                try {
                  const parsed = JSON.parse(prefill);
                  if (parsed && typeof parsed === 'object' && parsed.signature) {
                    // New format: extract just the signature for display
                    newFormState[field.id] = parsed.signature;
                  } else {
                    // Not the expected JSON format, use as-is
                    newFormState[field.id] = prefill;
                  }
                } catch (e) {
                  // Not JSON, use as-is (old format - just base64 string)
                  newFormState[field.id] = prefill;
                }
              } else {
                newFormState[field.id] = prefill;
              }
              shouldUpdate = true;
            }
          }
        });
      });
    
      if (shouldUpdate) {
        setFormState((prev) => ({ ...prev, ...newFormState }));
      }
      setInputFields(fields)
      setSeachText("")
    }, [fields]);
    
  
    useEffect(() => {
      if (!highlightTerm) {
        setExpandedSection(null); // collapse accordion
        return;
      }
    
      const lowerTerm = highlightTerm.toLowerCase();
    
      let matchedFormId = null;
    
      fields.forEach((form) => {
        const match = form.fields.some((field) => {
          const labelMatch = field.label?.toLowerCase().includes(lowerTerm);
          const optMatch = (field.options || []).some((opt) =>
            opt.value?.toLowerCase().includes(lowerTerm)
          );
    
          if (labelMatch || optMatch) {
            matchedFormId = form.emr_form_id;
            return true;
          }
    
          return false;
        });
      });
    
      if (matchedFormId) {
        setExpandedSection(matchedFormId); 
      }
    }, [highlightTerm, fields]);

  // Register save-current-charting so parent can auto-save when switching sections (invoked fn uses latest state via ref)
  useEffect(() => {
    if (typeof registerSaveCurrentCharting !== 'function') return;
    registerSaveCurrentCharting(() => latestSaveRef.current && latestSaveRef.current());
  }, [registerSaveCurrentCharting]);

  const handleSubmit = async (form_id, item) => {
    
    try {
      const emr_field = [];
      props.Loader(true)
      item.fields.forEach((field) => {
        const fieldValue = formState[field.id];
        const inputType = field.field_type?.input_type;
      
        if (inputType === "MULTI_SELECT" && Array.isArray(fieldValue)) {
          emr_field.push({
            field_id: field.id,
            value: fieldValue.join(","),
          });
        } else if (["SINGLE_SELECT", "TEXT_FIELD", "TEXT_AREA", "DATE"].includes(inputType)) {
          emr_field.push({
            field_id: field.id,
            value: typeof fieldValue === "string" ? fieldValue : "",
          });
        }
        else if (inputType === "DIGITAL_SIGNATURE" && fieldValue) {
          // For signatures, include signed date and time from organization timezone
          const signedDate = getCurrentDate();
          const signedTime = getCurrentTime();
          const signatureData = {
            signature: fieldValue,
            signed_date: signedDate,
            signed_time: signedTime
          };
          emr_field.push({
            field_id: field.id,
            value: JSON.stringify(signatureData),
          });
        }
        else{
          emr_field.push({
            field_id:field.id,
            value:formState[field.id],
          });
        }
      });

      const payload = {
        employee_id: employeeId,
        emr_field,
        screen_type: selectedSubTab,
      };

      const results = await EmrVisitsService.saveFields(
        null,
        visit_id,
        form_id,
        payload
      );

      setProgressApiTrigger((prev) => !prev);
  
      if (results?.status === 200 || results?.status === "SUCCESS") {
        // Dispatch event to notify AI suggestions that EMR was saved
        // This triggers polling for new suggestions
        // Check if this is a screen type that triggers AI suggestions
        const aiTriggerScreenTypes = ['HPI', 'MUSCULOSKELETAL', 'ORGAN_SYSTEMS', 'PROBLEM_FOCUSED', 
          'ROM_TESTING', 'EXAMINATION_LACERATIONS', 'X_RAY', 'LAB', 'DIAGNOSTIC', 'TREATMENTS', 
          'PRESCRIPTIONS', 'INJECT_VACCINES', 'DMES', 'REFERRALS'];
        
        if (aiTriggerScreenTypes.includes(selectedSubTab)) {
          // Dispatch custom event to notify AI component
          window.dispatchEvent(new CustomEvent('emr-saved', {
            detail: { screenType: selectedSubTab, visitId: visit_id }
          }));
        }
        
        setValidation({});
        props.setCompetedFormIds((prev) =>(Array.from(new Set([...prev, form_id]))));
        props.SetFinishedTabs((prev) =>(Array.from(new Set([...prev, selectedTab]))))    
        SetFinishedSubTabs((prev)=>(Array.from(new Set([...prev, selectedSubTab]))))    
        setNormalCheckedFormIds((prev) =>
                    prev.filter((id) => id !== form_id)
                );
        await handleTick(Array.from(new Set([...finishedTabs, selectedTab])),Array.from(new Set([...finishedSubTabs, selectedSubTab])))
        await props.handleNormalSubmit(form_id,0,0,);     
        // if(selectedSubTab==='X_RAY' || selectedSubTab==='LAB'){
        //   await props.ToggleOrders(form_id);
        // }   
        // if(selectedSubTab==='INJECT_VACCINES'){
        //   await props.addVaccineToogleHandler(form_id);
        // }    
        const savedState = {...formState}; // <--- NEW
        initialFormStateRef.current = {...initialFormStateRef.current, ...savedState}; // <--- NEW
        setIsFormDirty(false);
        Toast.success("Data has been added successfully.");
        if (typeof onFormUpdate === "function") {
          onFormUpdate(form_id);
        }
        return true;
      } else if (results.status === "ERROR") {
        const resultData = results.data;
        Toast.error("Some required information is missing.");
        let firstErrorFieldId = null;
        if (Array.isArray(resultData) && resultData[0] && isObject(resultData[0])) {
          firstErrorFieldId = Object.keys(resultData[0])[0] || null;
        } else if (isObject(resultData)) {
          const keys = Object.keys(resultData);
          if (keys.length) firstErrorFieldId = keys[0];
        }
        setValidation(() => {
          const newValidation = {};

          if (Array.isArray(resultData)) {
            resultData.forEach((itemWithErrorObject) => {
              if (isObject(itemWithErrorObject)) { 
                for (const key in itemWithErrorObject) {
                  if (Object.hasOwnProperty.call(itemWithErrorObject, key)) {
                    const message = itemWithErrorObject[key];
                    newValidation[key] = Array.isArray(message)
                      ? message.join(", ")
                      : message;
                  }
                }
              }
            });
          } else if (isObject(resultData)) {
            for (const key of Object.keys(resultData)) {
              const message = resultData[key];
              newValidation[key] = Array.isArray(message)
                ? message.join(", ")
                : message;
            }
          } else {
            Toast.error(resultData || "Something went wrong.");
          }
        
          return newValidation;
        });
        // Focus first invalid field; scroll the charting column only (not the whole page)
        if (firstErrorFieldId) {
          setTimeout(() => {
            const el = fieldRefs.current[firstErrorFieldId];
            const container = chartingColumnRef.current;
            if (el) {
              if (container && container.contains(el)) {
                const containerRect = container.getBoundingClientRect();
                const elRect = el.getBoundingClientRect();
                const elTopInContent = container.scrollTop + (elRect.top - containerRect.top);
                const offset = 24;
                container.scrollTo({ top: Math.max(0, elTopInContent - offset), behavior: 'smooth' });
              } else if (container) {
                const relativeTop = el.offsetTop;
                container.scrollTo({ top: Math.max(0, relativeTop - 24), behavior: 'smooth' });
              } else {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              const focusable = el.querySelector?.('input, select, textarea, [tabindex="0"]');
              if (focusable) focusable.focus();
            }
          }, 150);
        }
        return false; 
      }
    } catch (error) {
      console.error("Save failed:", error);
      Toast.error("Something went wrong while saving.");
      return false;
    }
    finally{
      props.Loader(false)
    }
  };

  // Keep ref updated so auto-save on section switch uses latest form state
  latestSaveRef.current = () => {
    const formId = isSet(fields[0]?.emr_form_id) ? fields[0].emr_form_id : '';
    const formItem = isSet(fields[0]) ? fields[0] : null;
    if (formId && formItem) return handleSubmit(formId, formItem);
    return Promise.resolve(false);
  };
 
  const handleChange = (fieldId, value, isMulti, isSingle) => {
    console.log("isChartingSectionDirty",props.isChartingSectionDirty);
    console.log("setIsFormDirty",props.isFormDirty);
      setIsFormDirty(true);
    console.log("setIsFormDirty newww",props.isFormDirty);
    console.log()
    // 2. Update the form state
    setFormState((prev) => {
      let finalValue = value;

      if (isMulti) {
        // Multi-select toggle logic (for checkboxes)
        const current = prev[fieldId] || [];
        finalValue = current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value];
      }
      
      // For all other inputs (single-select, text, date), finalValue remains 'value'

      return { ...prev, [fieldId]: finalValue };
    });

    // 3. Clear validation messages for the field being changed
    setValidation((prevValidation) => {
      const newValidation = { ...prevValidation };
      delete newValidation[fieldId];
      return newValidation;
    });
  };
  const clearHandler=async(formid)=>{
      let newFormState={}
      console.log("clearHandler called",allfields);
      allfields.forEach((form) => {
        form.fields.forEach((field) => {
          newFormState[field.id]='';
        });
      });
      //  fields.forEach((form) => {
      //   form.fields.forEach((field) => {
      //        newFormState[field.id]='';
      //   });
      // });
      setFormState((prev) => ({...newFormState }));
      setCompetedFormIds([])
      // Clear normal checked form IDs as well
      console.log("setNormalCheckedFormIds",setNormalCheckedFormIds);
      if (setNormalCheckedFormIds) {
        setNormalCheckedFormIds([]);
      }
     await props.handleNormalSubmit(formid,0,1,1); // Pass clearAll=1 for "Clear All" button  
     // Keep progress note panel in sync immediately after clear.
     setProgressApiTrigger((prev) => !prev);
     if (typeof fetchProgressNotesByScreen === "function") {
       await fetchProgressNotesByScreen();
     }
     
     // Remove tick from current subtab when data is cleared
     if (selectedSubTab && SetFinishedSubTabs) {
       // Remove current subtab from finished subtabs
       const updatedFinishedSubTabs = finishedSubTabs.filter(subtab => subtab !== selectedSubTab);
       SetFinishedSubTabs(updatedFinishedSubTabs);
       
       // Find the parent tab for this subtab
       let parentTabName = null;
       if (tabData && Array.isArray(tabData)) {
         for (const tab of tabData) {
           if (tab[tab.tab_name] && Array.isArray(tab[tab.tab_name])) {
             const subtabExists = tab[tab.tab_name].some(subtab => subtab.apikey === selectedSubTab);
             if (subtabExists) {
               parentTabName = tab.tab_name;
               break;
             }
           }
         }
       }
       
       // Check if any other subtabs in the same parent tab are still completed
       let hasOtherCompletedSubTabs = false;
       if (parentTabName && tabData && Array.isArray(tabData)) {
         const parentTab = tabData.find(tab => tab.tab_name === parentTabName);
         if (parentTab && parentTab[parentTabName]) {
           const otherSubTabs = parentTab[parentTabName].filter(subtab => subtab.apikey !== selectedSubTab);
           hasOtherCompletedSubTabs = otherSubTabs.some(subtab => updatedFinishedSubTabs.includes(subtab.apikey));
         }
       }
       
       // Update main tab status: remove from finishedTabs only if no other subtabs are completed
       if (selectedTab && SetFinishedTabs) {
         let updatedFinishedTabs = [...finishedTabs];
         if (!hasOtherCompletedSubTabs && parentTabName === selectedTab) {
           // Remove main tab from finished tabs if no other subtabs are completed
           updatedFinishedTabs = updatedFinishedTabs.filter(tab => tab !== selectedTab);
           SetFinishedTabs(updatedFinishedTabs);
         }
         
         // Update backend status
         if (handleTick) {
           await handleTick(updatedFinishedTabs, updatedFinishedSubTabs);
         }
       } else if (handleTick) {
         // If we don't have selectedTab info, just update with current finishedTabs
         await handleTick(finishedTabs, updatedFinishedSubTabs);
       }
     }
     
     console.log("fetch tab called",fields);
     fetchTabsList();
     // After Clear All, form is empty — don't block switch with required-field validation
     setValidation({});
     setIsFormDirty(false);
  }
  const searchHandler=(text)=>{
    setSeachText(text)
    if (text !== "") {
    const filterdata = fields.map((item) => {
      const filteredFields = item.fields
        .map((val) => {
          const matchesLabel = val.label?.toLowerCase().includes(text.toLowerCase());
          const filteredOptions = val.options?.filter((opt) =>
            opt.value?.toLowerCase().includes(text.toLowerCase())
          ) || [];
          if (matchesLabel || filteredOptions.length > 0) {
            return {
              ...val,
              options: filteredOptions.length > 0 ? filteredOptions : val.options, // replace with filtered options if any
            };
          }
          return null;
        })
        .filter(Boolean);

      return {
        ...item,
        fields: filteredFields,
      };
    });

      setInputFields(filterdata);
    }else{
       setInputFields(fields);
    }
    
  }
  const handleProceed = () => {
    props.setIsChartingSectionDirty(false);
    props.setIsFormDirty(false);
    props.setShowUnsavedAlert(false);
    if (props.pendingCallback) props.pendingCallback();
    // props.setPendingCallback(null);
  };
  
  const handleCancel = () => {
    props.setShowUnsavedAlert(false);
    props.setPendingCallback(null);
  };
  
  const handleSetAllToNormal = () => {
    console.log("all normal clicked");
    const updatedFormState = { ...formState };
    try {
      fields[0]?.fields.forEach((field) => {
        const { input_type, has_options, options } = field.field_type || {};

        // For fields with options like RADIO or CHECKBOX
        if (has_options && Array.isArray(field.options)) {
          const normalOpt = field.options.find(
            (opt) =>
              opt.value?.toLowerCase() === "normal" ||
              opt.value?.toLowerCase() === "negative"
          );

          if (normalOpt) {
            if (input_type === "SINGLE_SELECT") {
              updatedFormState[field.id] = normalOpt.id;
            } else if (input_type === "MULTI_SELECT") {
              updatedFormState[field.id] = [normalOpt.id];
            }
          }
        }

        // if (input_type === "NORMAL_ABNORMAL") {
        //   updatedFormState[field.id] = "NORMAL";
        // }

        // if (input_type === "POSITIVE_NEGATIVE") {
        //   updatedFormState[field.id] = "NEGATIVE";
        // }

        // if (input_type === "LEFT_RIGHT_BILATERAL") {
        //   updatedFormState[field.id] = {
        //     left: "NORMAL",
        //     right: "NORMAL",
        //   };
        // }

        // if (input_type === "RANGE_OF_MOTION") {
        //   updatedFormState[field.id] = field.options?.map(() => ({
        //     min_value: "0",
        //     max_value: "0",
        //   })) || [];
        // }

      });

      setFormState(updatedFormState);
      setIsFormDirty(true);
    } catch (err) {

    }
  };
  return (
    <>
    <div className="col-9">
      <div className="card sh_basecard">
        <div className="card-header p-2 sh_basecardHeader">
          {!fields || fields.length !== 0 &&
            <div className="d-flex w-100 justify-content-between align-items-center">
              {isSet(fields[0]?.name) ? isSet(fields[0].name) : ""}
              <div className="d-flex">
               <Buttons
                  className="btn sh_btnlight p3-light mr-2"
                  title={"Clear All"}
                  acl={'any'}
                  isDelete={true}
                  clickHandler={() =>
                    clearHandler(
                      isSet(fields[0]?.emr_form_id)
                        ? isSet(fields[0].emr_form_id)
                        : ""
                    )
                  }
                >
                  Clear All
                </Buttons>

                <Buttons className="btn btn-primary sh_btnprimary"
                title={"Accept"}
                acl={'any'}
                clickHandler={async () => {
                    const success = await handleSubmit(
                      isSet(fields[0]?.emr_form_id) ? isSet(fields[0].emr_form_id) : "",
                      isSet(fields[0]) ? isSet(fields[0]) : [],
                    );
                  }}
                >Accept / Replace</Buttons>
                
              </div>
            </div>}
        </div>

        <div
          ref={chartingColumnRef}
          data-charting-column
          className="card-body p-2 sh_basecardBody"
          style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 180px)' }}
        >
            {!fields || fields.length !== 0 &&  
                <div className="w-100">
                  <div className="position-relative w-50 my-1">
                    
                    {/* Search Icon */}
                    <span
                      className="position-absolute top-50 start-0 translate-middle-y ps-3"
                      style={{ pointerEvents: "none" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                      >
                        <path
                          fill="#616161"
                          d="m20.71 19.29-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 11a6 6 0 1 1 6 6 6 6 0 0 1-6-6z"
                        />
                      </svg>
                    </span>

                    {/* Input */}
                    <FormInputs
                      type="TextInput"
                      name="search_text"
                      className="form-control form-control-solid ps-5"
                      value={searchText}
                      placeholder="Search"
                      changeHandler={(val) => searchHandler(val)}
                    />
                  </div>
                </div>
                }
          {!inputFields || inputFields.length === 0 ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "40vh" }}
            >
              <div className="alert alert-info text-center m-0">
                No Charts and Fields Available. Please Add Charts.
              </div>
            </div>
          ) : (
            inputFields.map((item, idx) => {
              const setSectionRef = (el) => {
                if (el) sectionRefs.current[item.emr_form_id] = el;
              };
              if (item.view_type === "TABLE") {
                return <> 
                {(selectedTab === "History" || selectedTab === "Examination") && (
                 <div className='d-flex justify-content-end'> <span
                    className="sh_emr_roundbadge ml-1  chart"
                    onClick={handleSetAllToNormal}
                  >
                    N
                  </span></div>
                )}
                <table
                  className="table dataTable sh_emrtable table-borderless nowrap my-0"
                  width="100%"
                  cellSpacing="0"
                  style={{ width: '100%' }}
                >
                  <tbody>
                    {item.fields.length>0 ? item.fields.map((field, fIdx) => {
                      const fieldRef = (el) => {
                        if (el) {
                          fieldRefs.current[field.id] = el;
                        }
                      };
                      const { input_type, has_options } =
                        field.field_type || {};
                      const showOptions = has_options === 1;

                      return (<tr key={fIdx} ref={fieldRef} className='border-bottom' >
                        {input_type == "RANGE_OF_MOTION" || input_type == "EXERCISE" ? (
                          <td className="w-25 sh_emrtext">
                            <div className="d-flex align-items-center">
                              <h6 className="text-sm mb-0">
                                {field.label}
                                {/* {field.is_required && <span className="text-danger">*</span>} */}{" "}
                              </h6>
                              <span className={` cursor-pointer sh_emr_roundbadge ml-2 ${normalSelectedId === field.id && checked
                                ? "normal"
                                : "inactive"
                                }`}
                                title="All Normal"
                                onClick={() => {
                                  setIsFormDirty(true);
                                  setNormalSelectedId(field.id);
                                  if (normalSelectedId == field.id) {
                                    setChecked((prev) => !prev); // toggle checked state
                                  } else {
                                    setChecked(true); // always set to true when selecting a new field
                                  }
                                }}
                              >
                                N
                              </span>
                            </div>
                          </td>
                        ) : (
                          <td className="w-25 sh_emrtext">{field.label}
                            {field.is_required ? <span className="text-danger">*</span> : null}
                          </td>
                        )}
                        <td className="w-75">
                          {validation[field.id] && (
                            <div className="text-danger small mb-1">
                              {validation[field.id]}
                            </div>
                          )}
                          {["TEXT_FIELD", "TEXT_AREA", "DATE"].includes(input_type) && !showOptions && (
                            <div className="form-group w-100 mb-0">
                              <FormInputs
                                type={
                                  input_type === "TEXT_AREA"
                                    ? "TextArea"
                                    : input_type === "DATE"
                                      ? "Date"
                                      : "TextInput"
                                }
                                name={`field-${field.id}`}
                                className={
                                  input_type === "TEXT_AREA"
                                    ? "form-control"
                                    : "form-control form-control-solid"
                                }
                                value={formState[field.id] || ""}
                                rows={input_type === "TEXT_AREA" ? 6 : 1}
                                changeHandler={(val, { e }) => {
                                  const finalVal =
                                    input_type === "DATE"
                                      ? typeof val === "string"
                                        ? val
                                        : String(val)
                                      : val;
                                  handleChange(field.id, finalVal);
                                }}
                              />
                            </div>
                          )}

                          {["SINGLE_SELECT", "MULTI_SELECT"].includes(input_type) && showOptions && (
                            <div className="sh_tablecolumn">
                              {field.options.map((opt) => {
                                const isSelected =
                                  input_type === "SINGLE_SELECT"
                                    ? String(formState[field.id]) ===
                                    String(opt.id)
                                    : (formState[field.id] || [])
                                      .map(String)
                                      .includes(String(opt.id));

                                return (
                                  <div
                                    key={opt.id}
                                    className="form-group sh_emrtableformgroup mb-0"
                                  >
                                    <FormInputs
                                      id={`opt-${field.id}-${opt.id}`}
                                      type={
                                        input_type === "SINGLE_SELECT"
                                          ? "Radio"
                                          : "Checkbox"
                                      }
                                      name={`field-${field.id}`}
                                      className=""
                                      value={isSelected}
                                      changeHandler={(val, { e }) => {
                                        handleChange(
                                          field.id,
                                          opt.id,
                                          input_type === "MULTI_SELECT",
                                          input_type === "SINGLE_SELECT"
                                        );
                                      }}
                                    />

                                    <label
                                      // className="formlabel mb-0"
                                      htmlFor={`opt-${field.id}-${opt.id}`}
                                    >
                                      {opt.value}
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          )}

                          {input_type == 'LEFT_RIGHT_BILATERAL' &&
                            <>
                              <LeftRightInput
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                isExam={true}
                                setIsFormDirty={setIsFormDirty}
                              />
                            </>
                          }

                          {input_type == 'NORMAL_ABNORMAL' &&
                            <>
                              <NormalAbnormal
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                isExam={true}
                                normalSelectedId={normalSelectedId}
                                checked={checked}
                                setNormalSelectedId={setNormalSelectedId}
                                setChecked={setChecked}
                                setIsFormDirty={setIsFormDirty}
                              />
                            </>
                          }
                          {input_type == 'POSITIVE_NEGATIVE' &&
                            <>
                              <PositiveNegative
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                isExam={true}
                                setIsFormDirty={setIsFormDirty}
                              />
                            </>
                          }
                          {input_type == 'RANGE_OF_MOTION' &&
                            <>
                              <RangeOfMotion
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                normalSelectedId={normalSelectedId}
                                checked={checked}
                                setNormalSelectedId={setNormalSelectedId}
                                setChecked={setChecked}
                                isExam={true}
                                setIsFormDirty={setIsFormDirty}
                              />
                            </>
                          }
                          {input_type == "EXERCISE" && (
                            <Exercise
                              field={field}
                              setFormState={setFormState}
                              formState={formState}
                              value={formState[field.id]}
                              isExam={true}
                              normalSelectedId={normalSelectedId}
                              checked={checked}
                              setNormalSelectedId={setNormalSelectedId}
                              setChecked={setChecked}
                              setIsFormDirty={setIsFormDirty}
                            />
                          )}
                          {input_type == 'DROP_DOWN' &&
                            <>
                              <DropDown
                                field={field}
                                setFormState={setFormState}
                                handleChange={handleChange}
                                formState={formState}
                                value={formState[field.id]}
                                normalSelectedId={normalSelectedId}
                                checked={checked}
                                setNormalSelectedId={setNormalSelectedId}
                                setChecked={setChecked}
                                tableView={true}
                                setIsFormDirty={setIsFormDirty}
                              />
                            </>
                          }
                             {input_type == 'CUSTOM_MATRIX' ?
                                <CustomMatrix
                                  key={`${field.id}-${field.column_header || ''}`}
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                                  isExam={true}
                                  setIsFormDirty={setIsFormDirty}
                                />
                              :
                              ""
                            }
                        </td>
                      </tr>
                      )
                    }):
                    <div className="alert alert-info text-center m-0">No Data found</div>
                    }
                  </tbody>
                </table>
                </>
              } else {
                return <div className="card-body py-2 px-0">
                  {item.fields.length>0 ? item.fields.map((field, fIdx) => {
                    const fieldRef = (el) => {
                      if (el) {
                        fieldRefs.current[field.id] = el;
                      }
                    };
                    const { input_type, has_options } =
                      field.field_type || {};
                    const showOptions = has_options === 1;

                    return (
                      <div key={fIdx} className="row" ref={fieldRef}>
                        {["TEXT_FIELD", "TEXT_AREA", "DATE", "DIGITAL_SIGNATURE"].includes(input_type) && !showOptions && (
                          <div className="card w-100 mb-0 shadow-none border-0">
                            <div className="card-header sh_subaccordionheader">
                              <h6 className="text-sm mb-0">
                                {field.label}
                                {field.is_required ? <span className="text-danger">*</span> : ""}
                              </h6>
                              {validation[field.id] && (
                                <div className="text-danger small mt-1">
                                  {validation[field.id]}
                                </div>
                              )}
                            </div>
                            <div className="card-body py-0 px-0">
                              <div className="row">
                                <div className={`form-group ${input_type === "DIGITAL_SIGNATURE" ? "col-4" : "col-12"} mb-0 my-1`}>
                                  <FormInputs
                                    type={
                                      input_type === "TEXT_AREA"
                                        ? "TextArea"
                                        : input_type === "DATE"
                                          ? "Date"
                                          : input_type === "DIGITAL_SIGNATURE"
                                            ? "Signature"
                                            : "TextInput"
                                    }
                                    name={`field-${field.id}`}
                                    className={
                                      input_type === "TEXT_AREA"
                                        ? "w-100 m-1 sh_emrfieldtext form-control-solid"
                                        : "form-control form-control-solid"
                                    }
                                    value={
                                      formState[field.id] || ""
                                    }
                                    // {...(input_type === "TEXT_AREA" ? { rows: 6 } : {})}
                                    rows={input_type === "TEXT_AREA" ? 6 : 1}
                                    changeHandler={(val, options = {}) => {
                                      const { e } = options;
                                      const finalVal =
                                        input_type === "DATE"
                                          ? typeof val === "string"
                                            ? val
                                            : String(val)
                                          : val;
                                      handleChange(
                                        field.id,
                                        finalVal
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {["SINGLE_SELECT", "MULTI_SELECT"].includes(input_type) && showOptions && (
                          <div className="card w-100 mb-0 shadow-none border-0">
                            <div className="card-header sh_subaccordionheader">
                              <h6 className="text-sm mb-0">
                                {field.label}
                                {field.is_required ? <span className="text-danger">*</span> : ""}
                              </h6>
                              {validation[field.id] && (
                                <span className="text-danger small d-block mt-1">
                                  {validation[field.id]}
                                </span>
                              )}
                            </div>
                            <div className="card-body  py-2 px-0">
                              <div className="row">
                                {field.options.map(
                                  (opt, optIdx) => {
                                    const isSelected =
                                      input_type === "SINGLE_SELECT"
                                        ? String(
                                          formState[field.id]
                                        ) === String(opt.id)
                                        : (
                                          formState[field.id] ||
                                          []
                                        )
                                          .map(String)
                                          .includes(
                                            String(opt.id)
                                          );

                                    return (
                                      <div
                                        key={opt.id}
                                        className="form-group sh_emrtableformgroup  col-6 mb-0"
                                      >
                                        <div className="form-check">
                                          <FormInputs
                                            id={`opt-${field.id}-${opt.id}`}
                                            type={
                                              input_type ===
                                                "SINGLE_SELECT"
                                                ? "Radio"
                                                : "Checkbox"
                                            }
                                            name={`field-${field.id}`}
                                            className="form-check-input"
                                            value={isSelected}
                                            changeHandler={(
                                              val,
                                              { e }
                                            ) => {
                                              handleChange(
                                                field.id,
                                                opt.id,
                                                input_type ===
                                                "MULTI_SELECT",
                                                input_type ===
                                                "SINGLE_SELECT"
                                              );
                                            }}
                                          />
                                        </div>
                                        <label
                                          className="formlabel mb-0"
                                          htmlFor={`opt-${field.id}-${opt.id}`}
                                        >
                                          {opt.value}
                                        </label>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {input_type == 'LEFT_RIGHT_BILATERAL' ?
                          <>
                            <LeftRightInput
                              field={field}
                              setFormState={setFormState}
                              formState={formState}
                              value={formState[field.id]}
                              setIsFormDirty={setIsFormDirty}
                            />
                            {validation[field.id] && (
                              <div className="text-danger small mt-1">
                                {validation[field.id]}
                              </div>
                            )}
                          </>
                          :
                          ""
                        }
                        {input_type == 'NORMAL_ABNORMAL' ?
                          <>
                            <NormalAbnormal
                              field={field}
                              setFormState={setFormState}
                              formState={formState}
                              value={formState[field.id]}
                              setIsFormDirty={setIsFormDirty}
                            />
                            {validation[field.id] && (
                              <div className="text-danger small mt-1">
                                {validation[field.id]}
                              </div>
                            )}
                          </>
                          :
                          ""
                        }
                        {input_type == 'POSITIVE_NEGATIVE' ?
                          <>
                            <PositiveNegative
                              field={field}
                              setFormState={setFormState}
                              formState={formState}
                              value={formState[field.id]}
                              setIsFormDirty={setIsFormDirty}
                            />
                            {validation[field.id] && (
                              <div className="text-danger small mt-1">
                                {validation[field.id]}
                              </div>
                            )}
                          </>
                          :
                          ""
                        }
                        {input_type == 'EXERCISE' ?
                          <>
                            <Exercise
                              field={field}
                              setFormState={setFormState}
                              formState={formState}
                              value={formState[field.id]}
                              normalSelectedId={normalSelectedId}
                              checked={checked}
                              setNormalSelectedId={setNormalSelectedId}
                              setChecked={setChecked}
                              setIsFormDirty={setIsFormDirty}
                            />
                            {validation[field.id] && (
                              <div className="text-danger small mt-1">
                                {validation[field.id]}
                              </div>
                            )}
                          </>
                          :
                          ""
                        }
                        {input_type == 'RANGE_OF_MOTION' ?
                          <>
                            <RangeOfMotion
                              field={field}
                              setFormState={setFormState}
                              formState={formState}
                              value={formState[field.id]}
                              normalSelectedId={normalSelectedId}
                              checked={checked}
                              setNormalSelectedId={setNormalSelectedId}
                              setChecked={setChecked}
                              setIsFormDirty={setIsFormDirty}
                            />
                            {validation[field.id] && (
                              <div className="text-danger small mt-1">
                                {validation[field.id]}
                              </div>
                            )}
                          </>
                          :
                          ""
                        }
                        {input_type == 'DROP_DOWN' ?
                          <>
                            <DropDown
                              field={field}
                              setFormState={setFormState}
                              handleChange={handleChange}
                              formState={formState}
                              value={formState[field.id]}
                              normalSelectedId={normalSelectedId}
                              checked={checked}
                              setNormalSelectedId={setNormalSelectedId}
                              setChecked={setChecked}
                              setIsFormDirty={setIsFormDirty}
                            />
                            {validation[field.id] && (
                              <div className="text-danger small mt-1">
                                {validation[field.id]}
                              </div>
                            )}
                          </>
                          :
                          ""
                        }
                         {input_type=='CUSTOM_MATRIX'?
                                  <>
                                    <CustomMatrix
                                  key={`${field.id}-${field.column_header || ''}`}
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                              setIsFormDirty={setIsFormDirty}

                                  />
                                  {validation[field.id] && (
                                    <div className="text-danger small mt-1">
                                      {validation[field.id]}
                                    </div>
                                  )}
                                  </>
                                  :
                                  ""
                                  }
                      </div>

                    )
                  }):
                  <div className="alert alert-info text-center m-0"> No Data found</div>
                  }
                </div>
              }
            }
            ))}
        </div>
        
      </div>
      <div
  className="footer"
  style={{
    display: "flex",
    justifyContent: "flex-end", // aligns to the right
    padding: "10px",
    borderTop: "1px solid #ddd",
    backgroundColor: "#fff",
  }}
>
  {/* <Buttons
    className="btn btn-primary sh_btnprimary"
    title={"Accept"}
    acl={'any'}
    clickHandler={async () => {
      const success = await handleSubmit(
        isSet(fields[0]?.emr_form_id) ? isSet(fields[0].emr_form_id) : "",
        isSet(fields[0]) ? isSet(fields[0]) : [],
      );
    }}
  >
    Accept / Replace
  </Buttons> */}
</div>
    </div>
    {props.showUnsavedAlert && (
  <Alert
    contentTitle="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
    content="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
    yesButtonName="Discard"
    noButtonName="Cancel"
    type="warning"
    onDelete={handleProceed}   // ✅ Proceed
    onClose={handleCancel}     // ❌ Cancel
    confirmButtonClassName="btn btn-danger"
    cancelButtonClassName="btn btn-secondary"
    saveAndClose={true} 
    onSaveAndClose={async () => { 
      const formId = isSet(fields[0]?.emr_form_id) ? isSet(fields[0].emr_form_id) : "";
      const formItem = isSet(fields[0]) ? isSet(fields[0]) : [];
      const success = await handleSubmit(formId, formItem);
      if (success) {
        handleProceed();
      }
    }}
  />
)}
    </>
  )
}

export default WithRoutify(EmrRenderForm)